jQuery(($) => {
    $('.swipe-tabs').each(function () {
        const container = $(this).parent('.tabs')
        const tabs = $(this)
        const tabcontents = container.children('.swipe-tabs-container')

        const updateActiveTab = () => {
            setTimeout(() => { 
                const currentIndex = tabcontents.slick('slickCurrentSlide')
                tabs.slick('getSlick').$slides.each(function () {
                    $(this).toggleClass('is-active', $(this).data('slick-index') === currentIndex)
                })
            }, 0)
        }

        tabs.on('init', updateActiveTab)

        tabs.on('click', '.slick-slide', function(event) {
            event.preventDefault();
            var goToSingleSlide = $(this).data('slick-index');       
            tabcontents.slick('slickGoTo', goToSingleSlide);
        });

        tabcontents.on('afterChange', function () {
            updateActiveTab();
        });

        // Init contents
        tabcontents.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            draggable: false,
            fade: true,
            adaptiveHeight: true,
            asNavFor: tabs
        })

        // Init tabs
        tabs.slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
            asNavFor: tabcontents
        })
    })
});
